module.exports = __webpack_public_path__ + "img/cursive-workbook_B0992G14VV.8940ac6d.jpg";